import { DeityImage } from "./DeityImage";
import { FestivalImage } from "./FestivalImage";
import { SacredImage } from "./SacredImage";
import { SacredIcon } from "./SacredIcon";

/** Picks styled image component by sacred topic type. */
export function SacredTopicImage({ type, src, alt, size = "detail", className, testId }) {
  if (size === "icon") {
    return <SacredIcon src={src} alt={alt} className={className || "w-10 h-10 flex-shrink-0"} testId={testId} />;
  }
  if (type === "deity") {
    return <DeityImage src={src} alt={alt} size={size} className={className} testId={testId} />;
  }
  if (type === "festival") {
    return <FestivalImage src={src} alt={alt} size={size} className={className} testId={testId} />;
  }
  const variant = type === "vrata" ? "vrata" : type === "story" ? "story" : type === "sadhana" ? "sadhana" : "default";
  return (
    <SacredImage
      src={src}
      alt={alt}
      variant={variant}
      size={size === "row" ? "row" : "detail"}
      className={className}
      testId={testId}
    />
  );
}
